import React from "react";
import { useHistory } from "react-router-dom";
import { Button, useTitle } from "modules/common";
import { TermsOfUseContent } from "modules/auth";
import { AppRoutes } from "routing";

export const TermsOfUse: React.FC = () => {
  useTitle("Uvjeti korištenja - eSavjetnik");
  const history = useHistory();

  return (
    <div className="terms-of-use-page">
      <h1 className="mt-40 mr-40 ml-40">Uvjeti korištenja</h1>
      <TermsOfUseContent />
      <div className="mt-40 mr-40 ml-40 mb-48">
        <Button
          type="button"
          size="small"
          variant="warning"
          onClick={() => history.push(AppRoutes.Home)}
          className="mb-24"
        >
          <span>Natrag</span>
        </Button>
      </div>
    </div>
  );
};
